import { IState } from '../store';

export const getHiddenOfferStatus = (state: IState) => {
  return state.hideOffer.status;
};
